// Data access for the priority-support SLA panel. Shapes mirror
// apps/api/src/support-model.ts.
import type { ApiClient } from "./api";

export type SupportRequestStatus = "open" | "in_progress" | "done";

export interface SupportRequest {
  id: string;
  tenant_id: string;
  description: string;
  image_key: string | null;
  status: SupportRequestStatus;
  created_at: string;
  completed_at: string | null;
}

/** This calendar month's included-update quota. */
export interface SupportQuota {
  used: number;
  limit: number;
  remaining: number;
}

export interface SupportRequestsResult {
  requests: SupportRequest[];
  quota: SupportQuota | null;
}

export async function fetchSupportRequests(api: ApiClient): Promise<SupportRequestsResult> {
  const data = await api.request<{ requests?: SupportRequest[]; quota?: SupportQuota }>(
    "/tenant/support/requests"
  );
  return { requests: data.requests ?? [], quota: data.quota ?? null };
}

export async function createSupportRequest(
  api: ApiClient,
  input: { description: string; image_key?: string | null }
): Promise<SupportRequest> {
  const data = await api.request<{ request: SupportRequest }>("/tenant/support/request", {
    method: "POST",
    body: JSON.stringify(input),
  });
  return data.request;
}

export const SUPPORT_STATUS_LABELS: Record<SupportRequestStatus, string> = {
  open: "Open",
  in_progress: "In progress",
  done: "Done",
};
